export default {
  logout: () => 'success'
}
